import { render, staticRenderFns } from "./PatTopList.vue?vue&type=template&id=bf7df71c&scoped=true"
import script from "./PatTopList.vue?vue&type=script&lang=js"
export * from "./PatTopList.vue?vue&type=script&lang=js"
import style0 from "./PatTopList.vue?vue&type=style&index=0&id=bf7df71c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7df71c",
  null
  
)

export default component.exports